import { Col, Row, Spinner } from "@repo/ui";

import { RepTrainingProvider } from "../../contexts/editableItemContext";
import { useSettingsQuery } from "../../helpers/queryHooks";
import ManualTrainingEditorDynamic from "./manual";
import { MindFlash } from "./mindFlash";
import StateSpecificTraining from "./stateSpecific";
import { Props } from "./types";

function Training(props: Props) {
	return (
		<section id="TrainingContainer" className="container">
			<Row tag="section">
				<Col md="12">
					<RepTrainingProvider>
						<TrainingInternal {...props} />
					</RepTrainingProvider>
				</Col>
			</Row>
		</section>
	);
}

function TrainingInternal(props: Props) {
	const [settings, settingsLoaded] = useSettingsQuery();
	if (!settingsLoaded) return <Spinner>Loading...</Spinner>;

	if (settings?.mindflashEnabled) return <MindFlash {...props} />;

	if (settings?.trainingSettings?.stateSpecific) return <StateSpecificTraining {...props} />;

	return <ManualTrainingEditorDynamic {...props} />;
}
export default Training;
